import React, { Component } from 'react';
import ApplicantLogIn from './Components/ApplicantLogIn.js';
import ExtranetLogIn from './Components/Extranet/ExtranetLogIn.js';

declare var Cookies;
declare var globalSns;

class App extends Component {
    constructor(props) {
        super(props);

        this.onLoginSucceeded = this.onLoginSucceeded.bind(this);
        this.onRegisterRequest = this.onRegisterRequest.bind(this);
    }

    componentWillMount() {
        // Login or register => User may not be logged in, we make sure a registerd cookie is not present
        Cookies.remove("namezzz");
    }

    onLoginSucceeded(type) {
        switch (type) {
            case "applicant": window.location = globalSns.myHomepageUrl; break;
            case "extranet": window.location = globalSns.extranetUrl; break;
            default: break;
        }
    }

    onRegisterRequest(type) {
        switch (type) {
            case "applicant": window.location = globalSns.jobWizardUrl + "?newmember=true"; break;
            case "extranet": window.location = globalSns.extranetRequestUrl; break;
            default: break;
        } 
    }

    render() {
        return (
            <div className="login">
                <ApplicantLogIn onLoginSucceeded={(e) => this.onLoginSucceeded("applicant")} onRegisterRequest={(e) => this.onRegisterRequest("applicant")} />
                <ExtranetLogIn onLoginSucceeded={(e) => this.onLoginSucceeded("extranet")} onRegisterRequest={(e) => this.onRegisterRequest("extranet")} />
            </div>
        );  
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js